import './labelCellTable.scss';

type LabelCellTableProps = {
  picture: string;
  label: string;
};

export const LabelCellTable = ({ picture, label }: LabelCellTableProps) => (
  <div className="label-cell-container">
    <div className="sm-table-picture-container">
      <img src={picture} alt="sm-description" data-testid="sm-table_picture" />
    </div>
    <p>{label}</p>
  </div>
);
